import { createTheme } from '@mui/material/styles';

/**
 * MUI theme is kept in sync with the CSS design tokens in index.css so any
 * pages still on MUI components inherit the right colors during migration. New work should prefer Tailwind-based primitives in
 * `src/components/ui/`.
 */

const sharedTypography = {
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica", "Arial", sans-serif',
  button: {
    textTransform: 'none' as const,
    fontWeight: 600,
    letterSpacing: 0,
  },
  h1: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontWeight: 900, letterSpacing: '-0.04em' },
  h2: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontWeight: 900, letterSpacing: '-0.04em' },
  h3: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontWeight: 800, letterSpacing: '-0.035em' },
  h4: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontWeight: 800, letterSpacing: '-0.03em' },
  h5: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontWeight: 700, letterSpacing: '-0.025em' },
  h6: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontWeight: 700, letterSpacing: '-0.02em' },
};

const sharedShape = { borderRadius: 14 };

const sharedComponents = {
  MuiButton: {
    styleOverrides: {
      root: { borderRadius: 14, fontWeight: 600, textTransform: 'none' as const },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: { borderRadius: 20, backgroundImage: 'none' },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: { borderRadius: 20, backgroundImage: 'none' },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: { borderRadius: 14 },
    },
  },
};

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main:         '#00BF63',
      light:        '#D6F1E4',
      dark:         '#008F4A',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main:         '#E89A3C',
      light:        '#FBEBD0',
      dark:         '#B5701F',
      contrastText: '#111111',
    },
    error: { main: '#D94141' },
    warning: { main: '#E89A3C' },
    background: {
      default: '#FFFFFF',
      paper:   '#FFFFFF',
    },
    text: {
      primary:   '#111111',
      secondary: '#6E6E6E',
    },
    divider: '#E8E8E8',
  },
  typography: sharedTypography,
  shape: sharedShape,
  components: sharedComponents,
});
